import { Box, Flex, Image, Text } from '@mantine/core'
import React from 'react'
import ARROW from '../../images/ARROW.svg'

interface IConcludeSection {
    label: string
    children: React.ReactNode
}
const ConcludeSection = (props: IConcludeSection) => {
    return (
        <Flex direction='column'>
            <Flex gap='16px' align='center' mb='sm'>
                <Box>
                    <Image src={ARROW} w='10px' />
                </Box>
                <Text c='text.2' fw='bold'>
                    {props.label}
                </Text>
            </Flex>
            <Box pl='xl'>{props.children}</Box>
        </Flex>
    )
}

export default ConcludeSection
